/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-22 14:05:30
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Button, Card, Link, SkeletonBodyText } from '@shopify/polaris';
import SelectCustom from './Select';
import DeleteIcon from 'src/assets/images/sync/delete.svg';
import { getCollectionsUrl } from 'src/helpers';
import { connect } from 'react-redux';

const filterOption = (option, inputValue) =>
  (option.label.toString().toLowerCase().match(inputValue.toLowerCase()) || []).length > 0;

class SyncPriority extends Component<ComposedProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      tempCollections: _.cloneDeep(props.prioritizedCollections),
      render: null
    };
  }

  getCollectionsListOption = (allCollections, tempCollections, currentCollection) => {
    const tempCollectionsId = tempCollections.map(i => i.value);
    return allCollections.filter(collection => {
      return (
        !tempCollectionsId.includes(collection.value) ||
        collection.value === currentCollection.value
      );
    });
  };

  onChangeCollection = (index, e) => {
    const { tempCollections } = this.state;
    tempCollections[index] = e;
    this.setState(
      {
        tempCollections,
        render: Math.random()
      },
      () => {
        this.triggerChange();
      }
    );
  };

  onDeleteCollection = index => {
    this.setState(
      {
        tempCollections: this.state.tempCollections.filter((i, idx) => idx !== index)
      },
      () => {
        this.triggerChange();
      }
    );
  };

  onAddCollection = () => {
    this.setState(
      {
        tempCollections: [...this.state.tempCollections, {}]
      },
      () => {
        this.triggerChange();
      }
    );
  };

  triggerChange = () => {
    const { setTriggerUpdate, prioritizedCollections, onUpdate } = this.props;
    const { tempCollections } = this.state;

    const priorityIds = prioritizedCollections
      .filter(i => i.value)
      .map(col => col.value)
      .join('-');
    const tempIds = tempCollections
      .filter(i => i.value)
      .map(col => col.value)
      .join('-');

    if (priorityIds === tempIds) {
      setTriggerUpdate(false);
    } else {
      setTriggerUpdate(true);
    }

    onUpdate(this.state.tempCollections);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.prioritizedCollections !== this.props.prioritizedCollections) {
      this.setState({
        tempCollections: _.cloneDeep(nextProps.prioritizedCollections)
      });
    }
  }

  render() {
    const { i18n, allCollections, collectionsSuccess } = this.props;
    const { tempCollections } = this.state;

    const isAddableCollection = (() => {
      const allIdCollectionAvailable = allCollections.map(i => i.value);
      const allIdTempCollectionAvailable = tempCollections.map(i => i.value);
      const hasDifference = allIdCollectionAvailable.find(
        id => !allIdTempCollectionAvailable.includes(id)
      );
      return hasDifference;
    })();

    const renderCollections = tempCollections.map(collection => {
      if (!collection.value)
        return {
          ...collection,
          isBlank: true
        };
      const collectionFind = allCollections.find(i => i.value === collection.value);
      if (collectionFind) {
        return collectionFind;
      }
      return {
        ...collection,
        isDelete: true
      };
    });

    return (
      <Card sectioned title={i18n.translate('AdminHTML.Sync.SyncPriority.title')}>
        <div className="sync-collections-priority">
          <div> {i18n.translate('AdminHTML.Sync.SyncPriority.description')}</div>

          <div className="table">
            <div className="table-header">
              <div className="row">
                <div className="item">
                  {i18n.translate('AdminHTML.FilterTree.Common.collections')}
                </div>
                <div className="item">{i18n.translate('AdminHTML.Common.Action.actions')}</div>
              </div>
            </div>
            {!collectionsSuccess ? (
              <div className="table-body">
                <div className="row">
                  <div className="item">
                    <SkeletonBodyText lines={2} />
                  </div>
                  <div className="item">
                    <SkeletonBodyText />
                  </div>
                </div>
                <div className="row">
                  <div className="item">
                    <SkeletonBodyText lines={2} />
                  </div>
                  <div className="item">
                    <SkeletonBodyText />
                  </div>
                </div>
                <div className="row">
                  <div className="item">
                    <SkeletonBodyText lines={2} />
                  </div>
                  <div className="item">
                    <SkeletonBodyText />
                  </div>
                </div>
                <div className="row">
                  <div className="item">
                    <SkeletonBodyText lines={2} />
                  </div>
                  <div className="item">
                    <SkeletonBodyText />
                  </div>
                </div>
              </div>
            ) : (
              <div className="table-body">
                {renderCollections.map((collection, index) => {
                  return (
                    <div className="row" key={index}>
                      <div
                        className={`item ${collection.isDelete && 'has-collection-delete-border'} ${
                          collection.isBlank && 'has-collection-blank-border'
                        }`}>
                        {collection.isDelete && (
                          <div className="tooltip">
                            {i18n.translate('AdminHTML.Sync.SyncPriority.deleted', {
                              collection: collection.label
                            })}
                          </div>
                        )}
                        <SelectCustom
                          filterOption={filterOption}
                          placeholder={i18n.translate('AdminHTML.Sync.SyncPriority.select')}
                          openMenuOnFocus={true}
                          // ref={el => (itemsRef.current[index] = el)}
                          key={index}
                          options={this.getCollectionsListOption(
                            allCollections,
                            tempCollections,
                            collection
                          )}
                          onChange={e => this.onChangeCollection(index, e)}
                          value={collection.value ? collection : null}
                          className="SelectCollection"
                        />
                      </div>
                      <div className="item">
                        <Button onClick={() => this.onDeleteCollection(index)}>
                          <img src={DeleteIcon} alt="delete" width={20} height={20} />
                        </Button>
                      </div>
                    </div>
                  );
                })}
                <div className="row action">
                  <span
                    onClick={
                      tempCollections.length < 10 && isAddableCollection
                        ? this.onAddCollection
                        : () => {}
                    }
                    className={`add ${
                      tempCollections.length < 10 && isAddableCollection ? '' : 'disabled'
                    }`}>
                    + {i18n.translate('AdminHTML.Sync.SyncPriority.addCollection')}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="note">
            {collectionsSuccess ? (
              i18n.translate('AdminHTML.Sync.SyncPriority.note', {
                summary: (
                  <Link url={getCollectionsUrl()} external>
                    <span>
                      {i18n.translate('AdminHTML.Sync.SyncPriority.noteSummary', {
                        value: renderCollections.filter(i => !i.isDelete).length,
                        total: allCollections.length
                      })}
                    </span>
                  </Link>
                )
              })
            ) : (
              <SkeletonBodyText lines={2} />
            )}
          </div>
        </div>
      </Card>
    );
  }
}
export default withI18n()(connect(null, null)(SyncPriority));
